import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { ModalRef } from '@celerofinancas/ui-modals';
import { AmountGroup, CHARGE_LIST_TYPE } from '@celerofinancas/state-management';
import {
  BfmFinancialRecordDetailsComponent,
  FINANCIAL_RECORD_AMOUNT_FORM_CONFIGS,
  FINANCIAL_RECORD_AMOUNT_LIST_CONFIGS,
  FINANCIAL_RECORD_DETAILS_CONFIGS,
  FINANCIAL_RECORD_PAYMENT_INFO_CONFIGS,
  FinancialRecordDetailsService
} from "@celerofinancas/ui-cash-flow";
import {
  FINANCIAL_RECORD_AMOUNT_FORM_DEFAULT_CONFIGS_DEFAULT,
  FINANCIAL_RECORD_AMOUNT_LIST_DEFAULT_CONFIGS_DEFAULT,
  FINANCIAL_RECORD_DETAILS_CONFIGS_DEFAULT,
  FINANCIAL_RECORD_PAYMENT_INFO_DEFAULT_CONFIGS_DEFAULT, MONEY_PIPE_CONFIG_DEFAULT
} from "@pages/statement/modal-wrapper/modal-wrapper.component.values";
import { MONEY_PIPE_TOKEN } from "@celerofinancas/ui-pipes";

/**
 * Financial record details modal wrapper component
 */
@Component({
  selector: 'caixa-webcomponent-financial-record-modal-wrapper',
  templateUrl: './modal-wrapper.component.html',
  styleUrls: ['./modal-wrapper.component.scss'],
  standalone: true,
  imports: [
    BfmFinancialRecordDetailsComponent,
  ],
  providers: [
    {
      provide: MONEY_PIPE_TOKEN,
      useValue: MONEY_PIPE_CONFIG_DEFAULT,
    },
    {
      provide: FINANCIAL_RECORD_DETAILS_CONFIGS,
      useValue: FINANCIAL_RECORD_DETAILS_CONFIGS_DEFAULT,
    },
    {
      provide: FINANCIAL_RECORD_AMOUNT_LIST_CONFIGS,
      useValue: FINANCIAL_RECORD_AMOUNT_LIST_DEFAULT_CONFIGS_DEFAULT,
    },
    {
      provide: FINANCIAL_RECORD_PAYMENT_INFO_CONFIGS,
      useValue: FINANCIAL_RECORD_PAYMENT_INFO_DEFAULT_CONFIGS_DEFAULT,
    },
    {
      provide: FINANCIAL_RECORD_AMOUNT_FORM_CONFIGS,
      useValue: FINANCIAL_RECORD_AMOUNT_FORM_DEFAULT_CONFIGS_DEFAULT,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BfmFinancialRecordDetailsModalWrapperComponent implements OnInit {
  /**
   * Current modal reference
   */
  public modalRef = inject(ModalRef) as ModalRef<
    any,
    {
      financialRecordPk: string;
      showAuthorizationSection?: boolean;
      chargeType?: CHARGE_LIST_TYPE;
    }
  >;

  /**
   * Selected amount group signal
   */
  public selectedAmountGroup = signal<AmountGroup | null>(null);

  /**
   * Financial record details utils
   */
  private details = inject(FinancialRecordDetailsService);

  /**
   * Initializes the component
   */
  public ngOnInit() {
    this.modalRef.beforeClose = () => {
      if (this.details.hasExitRestrictions()) {
        this.details.openBalanceChangeWarning();
        return false; // Prevent modal from closing
      }
      return true; // Allow modal to close
    }
  }

  /**
   * Handles amount group selection
   * @param amountGroup
   */
  public onSelectAmountGroup(amountGroup: AmountGroup): void {
    this.selectedAmountGroup.set(amountGroup);
  }
}
